export interface SalesforceSaveObject {
  hiddenFields: any[];  // any[], because we don't use this data, just send it to backend as we received it
  fieldValues: {};
}

export interface SalesforceForm {
  hiddenFields: any[];
  sections: SalesforceFormSection[];
}

export interface SalesforceFormSection {
  label: string;
  fields: SalesforceField[];
}

export interface SalesforceField {
  isRequired: boolean;
  name: string;
  label: string;
  type: string;
  value: string | number | boolean | SalesforceReferenceFieldDefaultValue;
  isDependentPicklist?: boolean;
  referenceTo: SalesforceReferencedObject[];
  picklistValues: SalesforcePicklistValue[];

  controllerName?: string;
  controlledPicklistValues?: SalesforcePicklistValue[];
}

export interface SalesforceReferenceFieldDefaultValue {
  id: string;
  name: string;
}

export interface SalesforcePicklistValue {
  label: string;
  value: string;
  validFor?: string;
}

export interface SalesforceReferencedObject {
  name: string;
  value: string;
}

export interface SalesforceError {
  fieldLabel: string;
  fieldErrorMessage: string;
  rawErrorMessage: string;
}

export const SalesforceFieldTypes = {
  STRING: 'STRING',
  TEXTAREA: 'TEXTAREA',
  BOOLEAN: 'BOOLEAN',
  PICKLIST: 'PICKLIST',
  MULTIPICKLIST: 'MULTIPICKLIST',
  REFERENCE: 'REFERENCE',
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  PERCENT: 'PERCENT',
  INTEGER: 'INTEGER',
  DOUBLE: 'DOUBLE',
  URL: 'URL',
  ENCRYPTEDSTRING: 'ENCRYPTEDSTRING',
  CURRENCY: 'CURRENCY',
  DATE: 'DATE',
  DATETIME: 'DATETIME',
  TIME: 'TIME'
};
